import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { Alert, AlertTitle, Button } from '@mui/material'
import { useTranslation } from 'translations'

interface Props {
    accountSlug: string
}

const RtpProductsWarning: FC<Props> = ({ accountSlug }) => {
    const { t } = useTranslation()
    const history = useHistory()

    const goToProducts = () => {
        history.push(`/account/${accountSlug}/products/crud/new`)
    }

    return (
        <Alert severity="warning">
            <AlertTitle>{t('globalPricingSettings.studio.rtpWarning.title')}</AlertTitle>
            {t('globalPricingSettings.studio.rtpWarning.description')}&nbsp;
            <Button size="small" variant="contained" onClick={goToProducts}>
                {t('globalPricingSettings.studio.rtpWarning.setupButton')}
            </Button>
        </Alert>
    )
}

export default RtpProductsWarning
